import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FiltroAZ } from '../../../../core/model/inventories';
import { AzDetail } from '../../../../core/model/inventory-detail/az-detail';
import { Page } from '../../../../core/model/page';
import { Serie } from '../../../../core/model/serie';
import { InventariosService } from '../../../../core/services/inventarios.service';
import { SeriesService } from '../../../../core/services/series.service';
import { ShoppingElementsService } from '../../../../core/services/shopping-elements.service';

@Component({
  selector: 'app-filtros-az',
  templateUrl: './filtros-az.component.html',
  styleUrls: ['./filtros-az.component.css']
})
export class FiltrosAzComponent implements OnInit {

  @Input() page: Page;

  @Input() set reloadRecords(reload: boolean) {
    if (reload) {
      this.searchAZ();
    }
  }
  @Output() reloadRecordsChange = new EventEmitter<boolean>();

  @Output() loading = new EventEmitter<boolean>();
  @Output() azProcesados = new EventEmitter<AzDetail[]>();
  @Output() nivelInventarioSerie = new EventEmitter<number>();

  filtro = new FiltroAZ();
  clienteIdSelected: number;

  constructor(
    private inventarioService: InventariosService,
    private shoppingElementsService: ShoppingElementsService,
    private seriesService: SeriesService
  ) { }

  ngOnInit() { }

  setSerie(serie: any) {
    this.filtro.idSerie = parseInt(serie, 10);
    this.seriesService.getSerieById(this.filtro.idSerie).subscribe((ser: Serie) => this.nivelInventarioSerie.emit(ser.inventoryLevelId));
    this.azProcesados.emit([]);
  }

  setClientSelected(event) {
    this.clienteIdSelected = event.cliente;
    if (event.cliente === 0) {
      this.filtro.idSerie = undefined;
    }
  }

  limpiar() {
    this.filtro = new FiltroAZ();
  }

  searchAZReset() {
    this.page.pageNumber = 0;
    this.searchAZ();
  }

  searchAZ() {
    // this.page.pageNumber = 0;
    const inicio = this.page.size * this.page.pageNumber;
    const fin = inicio + (+this.page.size);
    this.loading.emit(true);
    this.inventarioService.searchInventarioAZ(inicio, fin, this.filtro)
      .subscribe((result: { CONTADOR: number, Documents: AzDetail[] }) => {
        this.page.totalElements = result.CONTADOR;
        result.Documents.forEach((doc: AzDetail) => doc.clienteId = this.clienteIdSelected);
        const azWithShoppingCart = this.shoppingElementsService.getRecordsWithCartInformation(result.Documents);
        this.azProcesados.emit(azWithShoppingCart);
        this.loading.emit(false);
        this.reloadRecordsChange.emit(false);
      });
  }

}
